import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
  showDescription?: boolean;
}

export default function MovieCard({ movie, showDescription = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg bg-background-100 border border-background-300/80 overflow-hidden hover:border-primary-500/70 transition-colors"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 嫩草影院高清在线看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-50/90 via-foreground-50/10 to-transparent opacity-80" />
        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-sm bg-foreground-50/70 backdrop-blur-sm text-[11px] text-foreground-900 border border-background-400/60">
          {movie.type === "movie" ? "电影" : "剧集"}
        </span>
        <span className="absolute top-2.5 right-2.5 px-1.5 py-0.5 rounded-sm bg-accent-500 text-foreground-50 text-[12px] font-semibold flex items-center gap-1">
          <i className="ri-star-fill text-[10px]" />
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-3 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-primary-500 text-white text-xs font-medium">
            <i className="ri-information-line" />
            查看详情
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 truncate">
          {movie.year} · {movie.region} · {movie.genres.join(" / ")}
        </p>
        {showDescription && (
          <p className="mt-2 text-xs leading-6 text-foreground-600 line-clamp-2">
            {movie.synopsis}
          </p>
        )}
      </div>
    </Link>
  );
}